export default "__VITE_ASSET__D7vU5xkE__"